import React from "react";

const Footer = () => {
  return (
    <footer className="border-t border-white/10 py-10 bg-[#070f1c]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 rounded-full relative overflow-hidden" style={{
            background: "linear-gradient(180deg,#ee1515 0 49%, #1a1a1a 49% 53%, #f5f5f5 53% 100%)"
          }}>
            <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-white border border-[#1a1a1a]" />
          </div>
          <span className="pixel-font text-[#ffcb05] text-[11px] tracking-wider">POKÉREALMS</span>
          <span className="text-white/40 text-sm ml-4">Powered by Solana</span>
        </div>

        <div className="flex items-center gap-6">
          <a href="https://x.com/pokerealmsfun" target="_blank" rel="noreferrer" className="text-white/60 hover:text-[#ffcb05] transition-colors flex items-center gap-2 text-sm">
            <span className="text-[#ffcb05] font-bold">𝕏</span> @pokerealmsfun
          </a>
        </div>
      </div>
      <p className="text-center text-xs text-white/35 mt-6">A web-based monster adventure · All creature designs belong to their respective owners.</p>
    </footer>
  );
};

export default Footer;
